<template>
  <div class="d-flex align-center" style="position: relative">
    <img
      :src="iconSrc"
      :style="{width: iconWidth, height: iconHeight}"
    >

    <!-- 즐겨찾기 표시 -->
    <img v-if="showFavorite && favorite"
      src="/assets/favorite-small.svg"
      style="position: absolute; right: 1px; bottom: 1px"
      :style="{width: `calc(${iconWidth}/2)`, height: `calc(${iconHeight}/2)`}"
    >
  </div>
</template>

<script>
import { getFileIconSrc } from "@/utils/fileMetadata"

export default {
  name: "TimelineIcon",

  props: {
    target_detail: {
      type: Object,
      default: () => {}
    },
    iconWidth: {
      type: String,
      default: '26px'
    },
    iconHeight: {
      type: String,
      default: '26px'
    },
    showFavorite: {
      type: Boolean,
      default: true
    },
    favorite: {
      type: Number,
      default: 0
    },
  },

  computed: {
    iconSrc() {
      return getFileIconSrc(this.target_detail)
    },
  },
}
</script>

<style scoped>
</style>
